import { STATUS } from '../../theme/tokens';

// Re-exported so chart modules keep one import for every token they use.
export { STATUS, SEQUENTIAL, fmt, fmtCompact, prettyLabel, relativeTime, statusBadge } from '../../theme/tokens';

/**
 * Chart tokens for the dashboard.
 *
 * The series hues are not a taste choice — they were run through the dataviz
 * palette validator against this app's actual chart surface (#ffffff, the
 * `.card` background) and pass every gate: lightness band, chroma floor,
 * colour-vision-deficiency separation (worst adjacent pair ΔE 24.7, target ≥8),
 * normal-vision floor (ΔE 33.6, floor ≥15) and ≥3:1 contrast.
 *
 * Adding a third series was deliberately rejected: aqua measured 2.82:1 against
 * white, which drops below the contrast gate and would oblige extra relief.
 * "Deleted" therefore lives in the tooltip and table view rather than as a bar.
 *
 * Text never wears a series colour — labels and values use the app's slate ink,
 * and identity comes from the coloured mark beside them.
 */

// Categorical slots 1 and 2 — identity, assigned in fixed order and never cycled.
export const SERIES = {
  new: '#2a78d6',       // slot 1 · blue
  modified: '#eb6834',  // slot 2 · orange
};

// Recessive chrome. Gridlines are solid hairlines — never dashed.
export const CHROME = {
  grid: '#eef0f4',
  baseline: '#d7dce4',
};

/** Severity for a success-rate style percentage. */
export const rateStatus = (rate) => {
  if (rate >= 95) return { key: 'good', color: STATUS.good, label: 'Healthy' };
  if (rate >= 80) return { key: 'warning', color: STATUS.warning, label: 'Degraded' };
  return { key: 'critical', color: STATUS.critical, label: 'Critical' };
};

/** Round a max value up to a clean axis top, so ticks read 0 / 500 / 1,000. */
export const niceCeil = (value) => {
  if (value <= 0) return 1;
  const mag = 10 ** Math.floor(Math.log10(value));
  const step = [1, 2, 2.5, 5, 10].find((s) => value <= s * mag) ?? 10;
  return step * mag;
};
